var React = require('react');

function MapMarkerSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M157.4 89.88A191.85 191.85 0 0 1 320 0c106 0 192 86 192 192 0 46.83-9.88 73.25-49.83 133.43zM300.8 502.4a24 24 0 0 0 38.4 0c18.6-26.69 35.23-50.32 50.14-71.47L131.47 231.62c10.71 52.55 50.15 99.78 169.33 270.78z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M3.37 31.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45z","className":"fa-primary","key":2})]);
}

MapMarkerSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = MapMarkerSlash;

MapMarkerSlash.default = MapMarkerSlash;
